import React from "react";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

import { messages } from "../../PostProduction.messages";
import styles from "./Slide4.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { useBlocks } from "@jelly/lesson";

export const Slide4: React.FC = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key={1} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S1_Title)}</h3>
                <block.infoBox text={formatMessage(messages.G4_P4_S4_S1_Note)} compact={true} />
              </div>,
              <div key={2} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S2_Title)}</h3>
                <p>{formatMessage(messages.G4_P4_S4_S2_Description)}</p>
              </div>,
              <div key={3} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S3_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S4_S3_Description) }} />
                <block.infoBox text={formatMessage(messages.G4_P4_S4_S3_Note)} compact={true} />
              </div>,
              <div key={4} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S4_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S4_S4_Description) }} />
                <block.infoBox text={formatMessage(messages.G4_P4_S4_S4_Note)} compact={true} />
              </div>,
              <div key={5} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S5_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S4_S5_Description) }} />
              </div>,
              <div key={6} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S6_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S4_S6_Description) }} />
              </div>,
              <div key={7} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S7_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S4_S7_Description) }} />
              </div>,
              <div key={8} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S8_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S4_S8_Description) }} />
              </div>,
              <div key={9} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S9_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S4_S9_Description) }} />
              </div>,
              <div key={10} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S4_S10_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S4_S10_Description) }} />
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
